"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LocaleHandler_1 = require("../locale/LocaleHandler");
var messageCode_1 = require("../utils/messageCode");
function getLocalizationData(config, locale) {
    var messages = LocaleHandler_1.getMessagesForLocale(config, locale) || {
        messageProperties: undefined,
        supportedLocales: undefined
    };
    return {
        locale: locale,
        messages: messages.messageProperties,
        supportedLocales: messages.supportedLocales,
        allLocales: config.allLocales,
        defaultLocale: config.DEFAULT_LOCALE
    };
}
exports.getLocalizationData = getLocalizationData;
function mergeLocalizationDataAltStore(LocalizationStore, defaultLocale) {
    var allLocales = [];
    if (LocalizationStore.supportedLocales && LocalizationStore.supportedLocales.length) {
        LocalizationStore.supportedLocales.forEach(function (locale) {
            allLocales.push(locale.lang);
        });
    }
    return {
        messages: LocalizationStore.messages,
        supportedLocales: LocalizationStore.supportedLocales,
        locale: LocalizationStore.locale,
        allLocales: allLocales,
        defaultLocale: defaultLocale || ''
    };
}
exports.mergeLocalizationDataAltStore = mergeLocalizationDataAltStore;
exports.LocalizationContext = react_1.default.createContext({
    messages: {},
    locale: '',
    supportedLocales: [],
    allLocales: [],
    defaultLocale: ''
});
function withLocalization(Component) {
    var LocalizedComponent = (function (_super) {
        __extends(LocalizedComponent, _super);
        function LocalizedComponent() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getMessage = function (code, args) { return messageCode_1.getMessage(_this.context.messages, code, args); };
            return _this;
        }
        LocalizedComponent.prototype.render = function () {
            return react_1.default.createElement(Component, __assign({}, this.props, this.context, { i18n: this.context, getMessage: this.getMessage }));
        };
        LocalizedComponent.contextType = exports.LocalizationContext;
        return LocalizedComponent;
    }(react_1.default.PureComponent));
    return LocalizedComponent;
}
exports.withLocalization = withLocalization;
//# sourceMappingURL=data:application/json;base64,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